// Represents a promotion logic applied to a cart item reference.
import type { CartItemReferenceAction } from './cart-item-reference-action';

export enum LogicType {
    PROMOTION = 'promotion',
    FREESHIP = 'freeship',
    CAMPAIGN = 'campaign',
    OTHER = 'other', // Fallback for undefined types
}
// Each logic can generate multiple actions (gift, discount, etc.).
export interface CartItemReferenceLogic {
    id?: string; // Unique identifier for the logic
    cartItemReferenceId: string; // Foreign key to CartItemReference
    logicType: LogicType; // Type of logic (promotion, freeship, campaign, etc.)
    logicId: number; // ID of the logic (e.g. promotion ID)
    logicName?: string; // Optional display name of the logic
    actions: CartItemReferenceAction[]; // List of actions generated by this logic
    createdAt?: string; // ISO timestamp of logic creation
    sessionId?: string; // Optional session ID for gift selection
    /**
     * Number of purchased items allocated to this rule for gift calculation.
     *
     * When a product has multiple promotion rules, the total purchase quantity
     * (reference.qty) is split across rules. Each rule receives a portion
     * (allocatedQty) and uses it to determine how many gifts the user earns.
     *
     * Example: User buys 14 items. Rule 1 and Rule 2 both apply.
     *   - Rule 1 ("buy 3 get 1 gift"): allocatedQty = 8 → floor(8/3) = 2 gifts
     *   - Rule 2 ("buy 2 get 1 gift"): allocatedQty = 6 → floor(6/2) = 3 gifts
     *
     * When not set, the sync service falls back to reference.qty (total purchase qty).
     */
    allocatedQty?: number;
}
